import { TrialResultQuery } from "@generated/graphql";
import { KnowledgeBlocks } from "pages/Testing/view/Personal/types";

type TrialAnswer = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<TrialResultQuery["trial"]>["examination"]["competencyMap"]["competences"]
      >[number]["knowledgeBlockCompetences"]
    >[number]["knowledgeBlock"]["skills"]
  >[number]["trialAnswer"]
>;

type TrialAnswerQuestion = TrialAnswer["question"];

export type ExpandedTrialAnswer = Pick<
  TrialAnswer,
  "id" | "score" | "time" | "file" | "criterionAssessments" | "partsIds"
> & {
  blockTitle: string;
  knowledgeBlockTitle: string;
  skillTitle: string;
  questionText: TrialAnswerQuestion["text"];
  questionType: TrialAnswerQuestion["type"];
  questionParts: TrialAnswerQuestion["parts"];
  candidateAnswer: TrialAnswer["answer"];
};

const getTrialAnswerList = (knowledgeBlocks: KnowledgeBlocks): Array<ExpandedTrialAnswer> => {
  const result: Array<ExpandedTrialAnswer> = [];

  if (!knowledgeBlocks) return result;

  knowledgeBlocks.forEach((block) => {
    const blockTitle = block.title;

    (block.knowledgeBlockCompetences || []).forEach((knowledgeBlockCompetence) => {
      const knowledgeBlockTitle = knowledgeBlockCompetence.knowledgeBlock.title;

      (knowledgeBlockCompetence.knowledgeBlock.skills || []).forEach((skill) => {
        const skillTitle = skill.title;

        const { trialAnswer } = skill;
        if (trialAnswer) {
          result.push({
            blockTitle,
            knowledgeBlockTitle,
            skillTitle,
            id: trialAnswer.id,
            file: trialAnswer.file,
            score: trialAnswer.score,
            time: trialAnswer.time,
            questionText: trialAnswer.question.text,
            questionType: trialAnswer.question.type,
            questionParts: trialAnswer.question.parts?.map(({ id, content, isCorrect }) => ({
              id,
              content,
              isCorrect,
            })),
            criterionAssessments: trialAnswer.criterionAssessments,
            candidateAnswer: trialAnswer.answer,
            partsIds: trialAnswer.partsIds,
          });
        }
      });
    });
  });

  return result;
};

export default getTrialAnswerList;
